import useApiFetch from '@/hooks/useApiFetch';
import useProfile from '@/hooks/useProfileV2';
import staffMemberServices from '@/services/staffMember';
import { FetchApiIds } from '@/types';
import HomeSidePanelComponent from './HomeSidePanel.component';

type HomeSidePanelProps = {
  className?: string;
};

const HomeSidePanel = (props: HomeSidePanelProps): JSX.Element => {
  const { profile, refresh: refreshUser } = useProfile();

  const { data: staffMember, isLoading: isLoadingStaffMember } = useApiFetch(
    [FetchApiIds.GET_STAFF_MEMBER_BY_PERSON, profile.person?.id],
    async () =>
      staffMemberServices.getStaffMemberByPersonId({ personId: profile.person?.id || '' }),
    { enabled: Boolean(profile.person?.id) }
  );

  const { data: getTeamStaffMambersData, isLoading: isLoadingTeamMembers } = useApiFetch(
    [FetchApiIds.GET_TEAM_STAFF_MEMBERS, staffMember?.team?.id],
    async () => staffMemberServices.getTeamStaffMembers({ teamId: staffMember?.team?.id || '' }),
    { enabled: Boolean(staffMember?.team?.id) }
  );

  const teamMembers = (getTeamStaffMambersData || []).map((member) => member.person);

  return (
    <HomeSidePanelComponent
      id={profile.person?.id}
      refreshUser={refreshUser}
      firstName={profile.person?.firstName}
      lastName={profile.person?.lastName}
      pictureUrl={profile.person?.pictureUrl || ''}
      developerType={profile.person?.developerType || undefined}
      jobInfo={staffMember?.jobInfo}
      team={staffMember?.team?.name}
      email={profile.email}
      mobilePhone={profile.person?.mobilePhone}
      linkedinUrl={profile.person?.linkedinUrl}
      trioProfileUrl={profile.person?.trioProfileUrl || undefined}
      hireDate={staffMember?.contract?.hireDate}
      managerFirstName={staffMember?.manager?.firstName}
      managerLastName={staffMember?.manager?.lastName}
      managerPicture={staffMember?.manager?.pictureUrl || undefined}
      managerType={staffMember?.manager?.developerType || undefined}
      teamMembers={teamMembers}
      isLoadingStaffMember={isLoadingStaffMember}
      isLoadingTeamMembers={isLoadingTeamMembers}
      {...props}
    />
  );
};

export default HomeSidePanel;
